import React, { ChangeEvent, Component } from "react";
import UIService from "../../../services/UIService";
import ChevronToggle from "../../shared/ChevronToggle/ChevronToggle";
import OwButton from "../../shared/OwButton/OwButton";
import OwDebouncedInput from "../../shared/OwDebouncedInput/OwDebouncedInput";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";

type Props = {
    searchFn: (sku?: string, loc?: string) => void;
    resetSearch: () => void;
};

type State = {
    isVisible: boolean;
    sku: string;
    loc: string;
};

export default class PickListDetailFilter extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            isVisible: true,
            sku: "",
            loc: "",
        };
    }

    componentDidMount(): void {}

    componentWillUnmount(): void {}

    toggleVisible = () => {
        this.setState({
            isVisible: !this.state.isVisible,
        });
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    search = () => {
        this.props.searchFn(this.state.sku, this.state.loc);
    };

    reset = () => {
        this.setState(
            {
                sku: "",
                loc: "",
            },
            () => {
                this.props.resetSearch();
            }
        );
    };

    render() {
        return (
            <div className={"PickListDetailFilter"}>
                <div className={"row"}>
                    <div className={"col-12 col-md-4 col-lg-2 mb-2"}>
                        <OwLabel title={"sku"} />
                        <OwInputWrapper name={"sku"} fn={this.handleChange} value={this.state.sku} />
                    </div>

                    <div className={"col-12 col-md-4 col-lg-2 mb-2"}>
                        <OwLabel title={"loc"} />
                        <OwInputWrapper name={"loc"} fn={this.handleChange} value={this.state.loc} />
                    </div>
                </div>

                <div className={"w-100 mb-2"}>
                    <OwButton title={"search"} fn={this.search} />
                    <OwButton title={"reset"} fn={this.reset} className={"ms-2 btn-danger"} />
                </div>
            </div>
        );
    }
}
